import { BetterButton } from '@dealerportal/ui-components/BetterButton';
import classNames from 'classnames';
import { useState } from 'react';

export const Prompt = ({
  message,
  position,
}: {
  message: string;
  position: string;
}) => {
  const [isOpen, setIsOpen] = useState(true);

  const promptClasses =
    position === 'right'
      ? 'ui-self-start ui-justify-start ui-rounded-bl-3xl'
      : 'ui-justify-end ui-self-end ui-rounded-br-3xl';
  return (
    <div
      className={classNames(
        {
          'ui-hidden': !isOpen,
          'ui-self-start ui-justify-start ui-rounded-bl-3xl':
            position === 'right',
          'ui-justify-end ui-self-end ui-rounded-br-3xl': position !== 'right',
        },
        'ui-max-w-72 ui-flex ui-items-center ui-gap-4 ui-pl-6 ui-pr-4 ui-py-4 ui-bg-white ui-shadow-2xl ui-rounded-t-3xl ui-border-solid ui-border ui-border-gray-200'
      )}
    >
      <div className="ui-leading-normal">{message}</div>

      <BetterButton
        btnStyle="neutral"
        attributes={{
          onClick: (e) => {
            e.stopPropagation();
            setIsOpen(false);
          },
        }}
        icon={
          // biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="ui-size-4 ui-shrink-0"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18 18 6M6 6l12 12"
            />
          </svg>
        }
        replaceClass={{
          '!ui-w-max': '!ui-size-8 ui-shrink-0',
          'ui-h-12': '',
          'ui-px-6': 'ui-px-0',
          '!ui-border-gray-700': '',
          '!ui-bg-white': '',
          'ui-rounded-md': 'ui-rounded-full',
        }}
      />
    </div>
  );
};
